import React, { useMemo } from 'react'
import { EventSponsorStrip, SponsorsShape } from '@/component/Primitive/Events'
import { bool, number, string } from 'prop-types'

const EventSponsorStripWidget = ({
  preText,
  sponsors,
  tierRank,
  dark: isDark
}) => {
  const lowestOrRankMatchedSponsors = useMemo(() => {
    let sponsorsToFilters = [...sponsors]
    let rankToFilterOn = tierRank

    if (!sponsorsToFilters.length) {
      return sponsorsToFilters
    }

    if (typeof rankToFilterOn !== 'number') {
      rankToFilterOn = sponsorsToFilters?.reduce((lowest, sponsor) => {
        const rank = sponsor.tier?.rank
        if (typeof rank !== 'number') {
          return lowest
        }

        return lowest === null || rank < lowest ? rank : lowest
      }, null)
    }

    sponsorsToFilters = sponsorsToFilters?.filter(
      (sponsor) => sponsor.tier?.rank === rankToFilterOn
    )

    if (sponsorsToFilters.length) {
      sponsorsToFilters = sponsorsToFilters.sort(
        (a, b) => a.orderIndex - b.orderIndex
      )
    }

    return sponsorsToFilters
  }, [sponsors, tierRank])

  if (!lowestOrRankMatchedSponsors.length) {
    return null
  }

  return (
    <EventSponsorStrip
      preText={preText}
      sponsors={lowestOrRankMatchedSponsors}
      isDark={isDark}
    />
  )
}

EventSponsorStripWidget.propTypes = {
  preText: string,
  tierRank: number,
  sponsors: SponsorsShape,
  dark: bool
}

export default EventSponsorStripWidget
